import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

export const SourceFields = ({ itemFormData, setItemFormData, completeSourceData, sourceTypeData, sourceCityData, sourceStateData }) => {
  const [sourceData, setSourceData] = useState([]);

  useEffect(() => {
    if (completeSourceData && completeSourceData.length > 0) {
      setSourceData(completeSourceData);
    }
  }, [completeSourceData]);

  const handleSourceChange = (event) => {
    const inputSourceName = event.target.value;
    const matchingSource = sourceData.find((source) => source.name === inputSourceName);
    if (matchingSource) {
      if (matchingSource.area_id) {
        setItemFormData((prevData) => ({
          ...prevData,
          source: {
            id: matchingSource.id,
            name: inputSourceName,
            type: {
              id: matchingSource.type_id,
              type: matchingSource.type
            },
            area: {
              id: matchingSource.area_id,
              city: {
                id: matchingSource.area[0].city_id,
                city: matchingSource.area[0].city
              },
              state: {
                id: matchingSource.area[0].state_id,
                state: matchingSource.area[0].state
              }
            }
          }
        }));
        return;
      }
      setItemFormData((prevData) => ({
        ...prevData,
        source: {
          id: matchingSource.id,
          name: inputSourceName,
          type: {
            id: matchingSource.type_id,
            type: matchingSource.type
          },
        }
      }));
      return;
    }
    setItemFormData((prevData) => ({
      ...prevData,
      source: {
        ...prevData.source,
        id: 0,
        name: inputSourceName
      }
    }));
  };

  const handleSourceTypeChange = (event) => {
    const value = event.target.value;
    const matchingType = sourceTypeData.find(sourceType => sourceType.type === value);
    const currentSourceType = matchingType ? matchingType : { id: 0, type: value };
    setItemFormData((prevData) => ({
      ...prevData,
      source: {
        ...prevData.source,
        type: currentSourceType
      }
    }));
  };

  const handleSourceCityChange = (event) => {
    const value = event.target.value;
    const matchingCity = sourceCityData.find(sourceCity => sourceCity.city === value);
    let potentialStates = []
    let probableState, areaId;
    if (matchingCity) {
      const matchingSources = sourceData.filter(source => source.area[0]?.city === matchingCity.city);
      matchingSources.forEach(matchingSource => {
        const newState = matchingSource.area[0].state;
        if (!potentialStates.includes(newState)) {
          potentialStates.push(newState);
        }
        areaId = matchingSource.area_id
        probableState = { id: matchingSource.area[0]?.state_id, state: matchingSource.area[0]?.state }
      });
      // areaId = matchingSources.area_id
    }
    const currentCity = matchingCity ? matchingCity : { id: 0, city: value };
    setItemFormData((prevData) => ({
      ...prevData,
      source: {
        ...prevData.source,
        area: {
          id: areaId || 0,
          city: currentCity,
          state: probableState || itemFormData.source.area.state
        }
      }
    }));
  };

  const handleSourceStateChange = (event) => {
    const value = event.target.value;
    const matchingState = sourceStateData.find(sourceState => sourceState.state === value);
    let areaId
    if (matchingState) {
      const matchingSources = sourceData.filter(source => source.area[0]?.state === matchingState.state);
      matchingSources.forEach(matchingSource => {
        const associatedCity = matchingSource.area[0]?.city;
        if (associatedCity === itemFormData.source.area.city) {
          areaId = matchingSource.area_id
        }
      });
    }
    const currentState = matchingState ? matchingState : { id: 0, state: value };
    setItemFormData((prevData) => ({
      ...prevData,
      source: {
        ...prevData.source,
        area: {
          ...prevData.source.area,
          id: areaId || 0,
          state: currentState
        }
      }
    }));
  };

  return (
    <>
      <div>
        <label>
          Source:
          <input
            type="text"
            name="source"
            value={itemFormData.source.name}
            onChange={handleSourceChange}
            list="sourceOptions"
            placeholder="Enter source name"
          />
          <datalist id="sourceOptions">
            {sourceData.map((source) => (
              <option key={source.id} value={source.name} />
            ))}
          </datalist>
        </label>
      </div>
      {sourceTypeData && (
        <div>
          <label>
            Source Type:
            <input
              type="text"
              name="sourceType"
              value={itemFormData.source.type.type}
              onChange={handleSourceTypeChange}
              list="sourceTypeOptions"
              placeholder="Enter source type"
            />
            <datalist id="sourceTypeOptions">
              {sourceTypeData.map((sourceType) => (
                <option key={sourceType.id} value={sourceType.type} />
              ))}
            </datalist>
          </label>
        </div>
      )}
      {sourceCityData && (
        <div>
          <label>
            Source City:
            <input
              type="text"
              name="sourceCity"
              value={itemFormData.source.area.city.city}
              onChange={handleSourceCityChange}
              list="sourceCityOptions"
              placeholder="Enter source city"
            />
            <datalist id="sourceCityOptions">
              {sourceCityData.map((sourceCity) => (
                <option key={sourceCity.id} value={sourceCity.city} />
              ))}
            </datalist>
          </label>
        </div>
      )}
      {sourceStateData && (
        <div>
          <label>
            Source State:
            <input
              type="text"
              name="sourceState"
              value={itemFormData.source.area.state.state}
              onChange={handleSourceStateChange}
              list="sourceStateOptions"
              placeholder="Enter source state"
            />
            <datalist id="sourceStateOptions">
              {sourceStateData.map((sourceState) => (
                <option key={sourceState.id} value={sourceState.state} />
              ))}
            </datalist>
          </label>
        </div>
      )}
    </>
  );
};

SourceFields.propTypes = {
  itemFormData: PropTypes.object.isRequired,
  setItemFormData: PropTypes.func.isRequired,
  completeSourceData: PropTypes.array,
  sourceTypeData: PropTypes.array,
  sourceCityData: PropTypes.array,
  sourceStateData: PropTypes.array
};

export default SourceFields;
